"use strict";
var $ = require("../internals/export");
var NATIVE_SYMBOL = require("../internals/symbol-constructor-detection");
var fails = require("../internals/fails");
var getOwnPropertySymbolsModule = require("../internals/object-get-own-property-symbols");
var toObject = require("../internals/to-object");
var FORCED = !NATIVE_SYMBOL || fails(function() {
  getOwnPropertySymbolsModule.f(1);
});
$({ target: "Object", stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});
